<template>
    <div
        class="transition-ease-in-out d-flex justify-center align-content-center py-5"
        :class="['dnd-area', 'text-center', fileUpload.dnd_over.value ? 'dnd-over' : 'dnd-out']"
        @dragover.stop.prevent="fileUpload.upload_dragover"
        @dragleave.stop.prevent="fileUpload.upload_dragleave"
        @drop.stop.prevent="uploadDrop"
    >
        <div style="display: initial; position: absolute; opacity: 0;">
            <input
                id="uploadedFile"
                ref="uploadedFile"
                type="file"
                name="uploadedFile"
                @change="uploadChange"
            />
        </div>
        <div
            v-if="fileUpload.upload_state.running"
            class="px-10 flex-grow-1"
        >
            <PrimaryLoadingBar :value="fileUpload.upload_progress"/>
            <div class="mt-3">
                <div v-if="fileUpload.upload_state.total_files === 0">{{ $t("Waiting for files") }}</div>
                <div v-else-if="fileUpload.upload_state.total_files === fileUpload.upload_state.uploaded_files">
                    {{ $t("Uploaded") }}
                </div>
                <div v-else>
                    {{ $t("Uploading...") }}
                </div>
            </div>
        </div>
        <label
            v-else
            for="uploadedFile"
        >
            <div style="height: 100%" class="d-flex align-center justify-center flex-column">
                <primary-button :disabled="disabled" @click="uploadFileClick($event)">
                    {{ buttonText }}
                </primary-button>
                <slot name="help"></slot>
            </div>
        </label>
    </div>
</template>

<script>
import {computed, ref} from "@vue/composition-api";
import DetailViewHeader from "@/components/DetailViewHeader";
import PrimaryLoadingBar from "@/components/LoadingBar/PrimaryLoadingBar";

export default {
    name: "FileUploadArea",
    components: {
        PrimaryLoadingBar,
        DetailViewHeader
    },
    props: {
        fileUpload: {
            type: Object,
            required: true
        },
        uploadDrop: {
            type: Function,
            required: true
        },
        uploadChange: {
            type: Function,
            required: true
        },
        buttonText: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {

        const uploadedFile = ref(null)

        const uploadFileClick = (event) => {
            if (!props.disabled) {
                uploadedFile.value.click(event)
            }
        }

        return {
            uploadedFile,
            uploadFileClick
        }
    }
};
</script>
